import { supabase } from '../config/supabaseClient';

export const getAppSetting = async (key) => {
  try {
    const { data, error } = await supabase.rpc('get_app_setting', { p_key: key });
    if (error) throw error;
    return { success: true, data };
  } catch (error) {
    console.error('Error fetching app setting:', error);
    return { success: false, error: error.message };
  }
};

export const updateAppSetting = async (key, value) => {
  try {
    const { data, error } = await supabase.rpc('update_app_setting', {
      p_key: key,
      p_value: String(value),
    });
    if (error) throw error;
    if (data && data.success === false) {
      throw new Error(data.message || 'Failed to update setting');
    }
    return { success: true, data };
  } catch (error) {
    console.error('Error updating app setting:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Read a setting together with its audit trail. app_settings.updated_by
 * references auth.users, so the editor's name needs a second lookup.
 */
export const getAppSettingMeta = async (key) => {
  try {
    const { data, error } = await supabase
      .from('app_settings')
      .select('setting_value, updated_at, updated_by, description')
      .eq('setting_key', key)
      .maybeSingle();
    if (error) throw error;
    if (!data) return { success: true, data: null };

    let updatedByName = null;
    if (data.updated_by) {
      const { data: editor } = await supabase
        .from('users')
        .select('full_name, email')
        .eq('id', data.updated_by)
        .maybeSingle();
      updatedByName = editor?.full_name || editor?.email || null;
    }

    return { success: true, data: { ...data, updatedByName } };
  } catch (error) {
    console.error('Error fetching app setting metadata:', error);
    return { success: false, error: error.message };
  }
};

export const getReferralCommission = async () => {
  const result = await getAppSetting('referral_commission_usd');
  if (result.success && result.data !== null) {
    const parsed = parseFloat(result.data);
    return isNaN(parsed) ? 10 : parsed;
  }
  return 10;
};
